const MenuIcon = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M3.09375 7.78955H21.0938"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M3.09375 12.7896H21.0938"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M3.09375 17.7896H21.0938"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
)

export default MenuIcon
